module["exports"] = [
  "back-uppen",
  "omzeilen",
  "hacken",
  "overschrijven",
  "samenpersen",
  "kopiëren",
  "navigeren",
  "indexeren",
  "aansluiten",
  "genereren",
  "kwantificeren",
  "berekenen",
  "samenstellen",
  "invoeren",
  "verzenden",
  "programmeren",
  "herstarten",
  "ontleden",
  "in stukjes snijden",
  "analyseren"

];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/hacker/verb.js
// module id = 3297
// module chunks = 1610